import { AvatarSize } from './types';

export const mapAvatarSizeClassName = (size?: AvatarSize) =>
  size !== 'md' ? `avatar-${size}` : undefined;
